module.exports = __webpack_public_path__ + "static/media/klaster.06ff7930.jpg";